import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Roles, UserAttributes } from '../../../authentication/data-access/models/auth.model';

@Injectable({
  providedIn: 'root',
})
export class UserStore {
  private store = new BehaviorSubject<UserAttributes>(
    new Object() as UserAttributes,
  );

  get(): Observable<UserAttributes> {
    return this.store;
  }

  set(user: UserAttributes) {
    this.store.next(user);
  }

  getUserRoles(): Roles[] {
    return this.store.getValue().roles ?? [];
  }

  hasRole(requiredRoles: Roles[]): boolean {
    const currentUsersRoles = new Set(this.getUserRoles());
    return requiredRoles.some(role => currentUsersRoles.has(role));
  }
}
